import { useParams, Navigate } from "react-router-dom";
import { getGroup, getOffence } from "@/data/servicesIA";
import { PageHero, Breadcrumbs } from "@/components/Shared";
import ServiceDetailBody from "@/components/ServiceDetailBody";

export default function ServiceDetail() {
  const { group: groupSlug, slug } = useParams();
  const group = getGroup(groupSlug);
  const offence = getOffence(groupSlug, slug);
  if (!group) return <Navigate to="/services" replace />;
  if (!offence) return <Navigate to={`/services/${groupSlug}`} replace />;

  const related = group.children
    .filter((c) => c.slug !== slug)
    .slice(0, 4)
    .map((c) => ({ label: c.title, href: `/services/${group.slug}/${c.slug}` }));

  return (
    <main data-testid="service-detail-page">
      <PageHero eyebrow={group.title} title={offence.title} lead={offence.tagline} />
      <Breadcrumbs
        items={[
          { label: "Our Services", href: "/services" },
          { label: group.title, href: `/services/${group.slug}` },
          { label: offence.title },
        ]}
      />
      <ServiceDetailBody item={offence} related={related} />
    </main>
  );
}
